import * as React from 'react';
import { useContext } from 'react';

export interface CheckoutContext {
  contextItemId: string;
}

const checkoutReactContext = React.createContext<CheckoutContext | null>(null);

export const CheckoutContextProvider = checkoutReactContext.Provider;

export const useCheckoutContext = () => {
  const context = useContext(checkoutReactContext);
  if (!context) {
    throw new Error(
      'Attempted to access checkout context before initializing it, please use CheckoutContextProvider to initialize the context.'
    );
  }

  return context;
};
